<template>
  <div v-if="show" class="loading-overlay">
    <div class="loading-content">
      <div
        class="spinner-border text-primary"
        role="status"
        style="width: 3rem; height: 3rem"
      >
        <span class="visually-hidden">{{ loadingText }}</span>
      </div>
      <p class="mt-3 text-white">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingOverlay",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Procesando...",
    },
    loadingText: {
      type: String,
      default: "Cargando...",
    },
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(3px);
  /* Por debajo de SweetAlert2 (1060) para no tapar errores de validación al guardar */
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-content {
  text-align: center;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
</style>
